import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";

import NewPhoneIcon from "@/assets/NewPhoneIcon";
import fileNumberIcon from "@/assets/filenumber.svg";

import { calculateAge, formatCalendarDate, setCaseId, setClientId } from "../../Utils/helper";
import incidentIcon from "../../assets/images/incident.svg";
import birthdayIcon from "../../assets/images/birthdayicon.svg";
import "./navbarProfile.css";
import { setDynamicWidth } from "../../Redux/header_width/action";
import { setBlurEffect } from "../../Redux/header_blur/action";
import { fetchCaseSummary } from "../../api/case";
import {
  fetchAllPages,
  fetchCurrentCase,
  setCaseSummary,
} from "../../Redux/caseData/caseDataSlice";
import api from "../../api/api";
import { setComponentLoadingEffect } from "../../Redux/common/Loader/action";
import { setHeaderName } from "../../Redux/header_name/action";
import { LoadingOverlay, useAccessValidation } from "../../Providers/ProtectedRoute";
import { fetchCasePageClientProviders } from "../../api/clientProviders";
import { setClientProviders, setLoading } from "../../Redux/client-providers/clientProviderSlice";

import avatarImage from "./../../assets/images/avatar.svg";
import CustomSkeleton from "./Skeleton";
import LastAccessedCases from "./LastAccessedCases";
import LastAccessedCasesModal from "./LastAccessedCasesModal";
const NewNavbarProfile = () => {
  const { validateAccessManually } = useAccessValidation();
  const headerData = useSelector((state) => state?.headerData.headerSummary);
  const client = headerData?.client_data;
  const caseSummary = headerData?.case_data;
  const _last_accessed_date = headerData?.last_accessed_date;

  // const client = useSelector((state) => state?.caseData?.summary?.for_client);
  // const caseSummary = useSelector((state) => state?.caseData?.summary);

  const lastAccessedCases = useSelector((state) => state?.caseData?.lastAccessedCases);
  const navigate = useNavigate();
  const page = "";

  const dynamicWidth = useSelector((state) => state?.dynamicWidth?.dynamicWidth);
  const dispatch = useDispatch();
  const [showRecentCases, setShowRecentCases] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openingCase, setOpeningCase] = useState(null);
  const [caseSwitchError, setCaseSwitchError] = useState("");
  const caseSwitchPendingRef = useRef(false);

  // useEffect(() => {
  //   calculateLongestNameWidth();
  // }, [lastAccessedCases]);

  // const calculateLongestNameWidth = () => {
  //   let longestNameLength = 0;
  //   lastAccessedCases?.forEach((temp) => {
  //     const nameLength = `${temp.for_client.last_name}, ${temp.for_client.first_name}`?.length;
  //     if (nameLength > longestNameLength) {
  //       longestNameLength = nameLength;
  //     }
  //   });
  //   const nameLength = `${client?.last_name}${client?.first_name ? `, ${client.first_name}` : ""}`.length;

  //   if (nameLength > longestNameLength) {
  //     longestNameLength = nameLength;
  //   }

  //   const nameWidth = longestNameLength <= 26 ? 19 : longestNameLength <= 30 ? 17 : 16;

  //   const width = Math.max(420, longestNameLength * nameWidth);
  //   dispatch(setDynamicWidth(width));
  // };

  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".header-wrapper-client")
      ) {
        setShowRecentCases(false);
        dispatch(setBlurEffect(false));
        document.body.classList.remove("modal-open", "has-blurred-bg");
        const menuContainer = document.getElementById("padding-top-165");
        if (menuContainer) {
          menuContainer.style.filter = "";
        }
        const divToRemove = document.querySelector(".header-blur-show");
        if (divToRemove) {
          document.body.removeChild(divToRemove);
        }
      }
    }
    if (showRecentCases) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showRecentCases]);

  const [_containerWidth, setContainerWidth] = useState(window.innerWidth);
  const [EmptySlotsCount, setEmptySlotsCount] = useState();
  const [FilledSlotsCount, setFilledSlotsCount] = useState();
  useEffect(() => {
    const adjustGridLayout = () => {
      const container = dropdownRef.current;
      if (!container) return;

      let availableWidth = container.parentElement.getBoundingClientRect().width;
      let availableHeight = window.innerHeight - container.offsetTop;

      const caseHeight = 120;
      // eslint-disable-next-line no-constant-binary-expression
      const minWidth = dynamicWidth + 7.5 ?? 0;
      const spacing = window.innerWidth - availableWidth;
      availableWidth = availableWidth - spacing;
      setContainerWidth(availableWidth);

      const columns = Math.floor(availableWidth / minWidth);
      const rows = Math.floor(availableHeight / caseHeight);

      availableHeight = rows * caseHeight;
      const totalVisibleSlots = columns * rows;
      const filledSlots = Math.min(totalVisibleSlots, lastAccessedCases?.length);
      const emptySlotsCount = totalVisibleSlots - filledSlots;

      const columnsWidth = Math.max(availableWidth / columns, dynamicWidth + 7.5);

      container.style.gridTemplateColumns = `repeat(${columns}, ${columnsWidth}px)`;
      container.style.gridTemplateRows = `repeat(${rows}, ${caseHeight}px)`;
      container.style.setProperty("width", `${availableWidth}px`, "important");
      container.style.height = `${availableHeight}px`;

      if (isLoading) {
        container.style.setProperty("width", `${availableWidth}px`, "important");
        container.style.height = `${availableHeight}px`;
        container.style.backgroundColor = "var(--primary-10)";
      }

      setEmptySlotsCount(emptySlotsCount);
      setFilledSlotsCount(filledSlots);

      for (let i = 0; i < filledSlots; i++) {
        const rowIndex = Math.floor(i / columns);
        const colIndex = i % columns;
        const slotElement = container.children[i];

        if (slotElement) {
          if ((rowIndex + colIndex) % 2 === 0) {
            slotElement.classList.add("bg-checkerboard-primary");
            slotElement.classList.remove("bg-checkerboard-secondary");
          } else {
            slotElement.classList.add("bg-checkerboard-secondary");
            slotElement.classList.remove("bg-checkerboard-primary");
          }
        }
      }

      for (let i = filledSlots; i < totalVisibleSlots; i++) {
        const rowIndex = Math.floor(i / columns);
        const colIndex = i % columns;
        const slotElement = container.children[i];

        if (slotElement) {
          if ((rowIndex + colIndex) % 2 === 0) {
            slotElement.classList.add("bg-checkerboard-primary");
            slotElement.classList.remove("bg-checkerboard-secondary");
          } else {
            slotElement.classList.add("bg-checkerboard-secondary");
            slotElement.classList.remove("bg-checkerboard-primary");
          }
        }
      }
    };

    adjustGridLayout();

    const handleResize = () => {
      adjustGridLayout();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [lastAccessedCases, dynamicWidth, isLoading, showRecentCases]);

  function extractDigits(phoneNumber) {
    return phoneNumber.replace(/\D/g, "");
  }

  const skewAmount1 = useMemo(() => {
    const angleInDegrees = 11.31;
    const angleInRadians = (angleInDegrees * Math.PI) / 180;
    return Math.tan(angleInRadians) * 75; // Adjust based on height
  }, []);

  const skewAmount2 = useMemo(() => {
    const angleInDegrees2 = 11.31;
    const angleInRadians2 = (angleInDegrees2 * Math.PI) / 180;
    return Math.tan(angleInRadians2) * 50; // Adjust based on height
  }, []);
  useEffect(() => {
    const rectangle = document.querySelector(".header-client-details");
    if (rectangle) {
      rectangle.style.clipPath = `polygon(${skewAmount1}px 0, calc(100% - ${skewAmount1}px) 0, 100% 100%, 0 100%)`;
    }
  }, [skewAmount1]);

  useEffect(() => {
    const rectangle2 = document.querySelector(".header-top-user-doi");
    if (rectangle2) {
      rectangle2.style.clipPath = `polygon(${skewAmount2}px 0, calc(100% - ${skewAmount2}px) 0, 100% 100%, 0 100%)`;
    }
  }, [skewAmount2]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const displayRecentCasesModal = () => {
    setIsModalOpen(true);
  };

  const clientInitials = `${client?.first_name?.charAt(0)}${client?.last_name?.charAt(0)}`;

  const [_isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1100);
  const [isLargeScreen, setIsLargeScreen] = useState(true);
  const [changeHeaderInfoLayout, setChangeHeaderInfoLayout] = useState(false);
  useLayoutEffect(() => {
    const headerCaseInfoElements = [...document.querySelectorAll(".header-top-user-doi")];
    const headerClientInfo = document.querySelector(".header-wrapper-client");

    if (headerClientInfo) {
      headerClientInfo.style.width = `${dynamicWidth}px`;
    }

    headerCaseInfoElements.forEach((el) => {
      el.style.width = `${dynamicWidth + 18}px`;
    });
  }, [dynamicWidth]);

  let shrinkingWidth = null;
  let shrinkingWidthFor29px = null;
  const _setClientInfoWidth = () => {
    const headerCaseInfo = document.querySelector(".header-top-user-doi");
    const headerClientInfo = document.querySelector(".header-wrapper-client");
    const headerRightInfo = document.querySelector(".top-nav-wrapper");
    const iconContainer = document.querySelector(".avatar-container");
    const headerClientName = document.querySelector(".client_name_header");
    const innerHeaderInfo = document.querySelector(".inner-header-info");
    // Define this at the top of your file or component (outside the function)

    if (
      !headerCaseInfo &&
      !headerClientInfo &&
      !headerRightInfo &&
      !iconContainer &&
      !headerClientName &&
      !innerHeaderInfo
    )
      return;

    const headerRightInfoWidth = headerRightInfo.getBoundingClientRect().width;

    if (window.innerWidth <= 1100) {
      const el1 = document.querySelector(".client_name_header");
      const el2 = document.querySelector(".chevron-header-icon");

      const el3 = document.querySelector(".client_phone_header");
      const el4 = document.querySelector(".client_birth_header");
      const el5 = document.querySelector(".client_phone_header1");
      const el6 = document.querySelector(".client_birth_header1");

      const el7 = document.querySelector(".client-header-case-name");
      const el8 = document.querySelector(".client-header-case-date");

      const el9 = document.querySelector(".client-header-incident-date");
      const el10 = document.querySelector(".client-header-incident-date-1");

      if (!el1 || !el2 || (!el3 && !el4) || (!el5 && !el6) || (!el7 && !el8) || (!el9 && !el10))
        return;

      const isDistance60px = checkDistance(el1, el2);
      const isDistance60px2 = checkDistance(el3, el4);
      const isDistance60px3 = checkDistance(el5, el6);
      const isDistance60px4 = checkDistance(el7, el8);
      const isDistance60px5 = checkDistance(el9, el10);
      const iconWidth = iconContainer.getBoundingClientRect().width;
      const checkCondition =
        isDistance60px || isDistance60px2 || isDistance60px3 || isDistance60px4 || isDistance60px5;
      if (checkCondition && iconWidth === 29) {
        headerClientInfo.style.width = `calc(100% - ${headerRightInfoWidth}px)`;
        headerCaseInfo.style.width = `${headerClientInfo.getBoundingClientRect().width + 18}px`;
        iconContainer.style.width = "19px";
        iconContainer.style.height = "19px";
        iconContainer.style.marginTop = "2px";
        headerClientName.style.fontSize = "14px";
        setChangeHeaderInfoLayout(true);
        return;
      } else if (
        shrinkingWidthFor29px &&
        window.innerWidth > shrinkingWidthFor29px &&
        iconWidth === 19
      ) {
        headerClientInfo.style.width = `calc(100% - ${headerRightInfoWidth}px)`;
        headerCaseInfo.style.width = `${headerClientInfo.getBoundingClientRect().width + 18}px`;
        iconContainer.style.width = "29px";
        iconContainer.style.height = "29px";
        headerClientName.style.fontSize = "24px";
        iconContainer.style.marginTop = "-3px";
        setChangeHeaderInfoLayout(true);
        return;
      } else if (shrinkingWidth && window.innerWidth > shrinkingWidth && iconWidth === 19) {
        headerClientInfo.style.width = `calc(100% - ${headerRightInfoWidth}px)`;
        headerCaseInfo.style.width = `${headerClientInfo.getBoundingClientRect().width + 18}px`;
        iconContainer.style.width = "19px";
        iconContainer.style.height = "19px";
        iconContainer.style.marginTop = "2px";
        headerClientName.style.fontSize = "14px";
        setChangeHeaderInfoLayout(true);
        return;
      } else if (checkCondition && iconWidth === 19) {
        if (shrinkingWidth === null) {
          shrinkingWidth = window.innerWidth; // lock it only once
        }
        const clientWidth = headerClientInfo.getBoundingClientRect().width;
        headerClientInfo.style.width = `${clientWidth}px`;
        headerCaseInfo.style.width = `${clientWidth + 18}px`;
        headerClientName.style.fontSize = "14px";
        iconContainer.style.marginTop = "2px";
        setIsLargeScreen(false);
        setChangeHeaderInfoLayout(true);
        return;
      } else if (checkCondition) {
        if (shrinkingWidth === null) {
          shrinkingWidthFor29px = window.innerWidth; // lock it only once
        }
        headerClientInfo.style.width = `calc(100% - ${headerRightInfoWidth}px)`;
        headerCaseInfo.style.width = `${headerClientInfo.getBoundingClientRect().width + 18}px`;
        iconContainer.style.width = "29px";
        iconContainer.style.height = "29px";
        headerClientName.style.fontSize = "24px";
        iconContainer.style.marginTop = "-3px";
        setChangeHeaderInfoLayout(true);
        return;
      }

      headerClientInfo.style.width = `calc(100% - ${headerRightInfoWidth}px)`;
      headerCaseInfo.style.width = `${headerClientInfo.getBoundingClientRect().width + 18}px`;
      return;
    }
    shrinkingWidth = null;
    shrinkingWidthFor29px = null;
    headerClientInfo.style.width = `${dynamicWidth}px`;
    headerCaseInfo.style.width = `${dynamicWidth + 18}px`;
    iconContainer.style.width = "63px";
    iconContainer.style.height = "63px";
    headerClientName.style.fontSize = "24px";
    innerHeaderInfo.classList.add("move-right");
    innerHeaderInfo.classList.remove("move-left");
    iconContainer.style.marginTop = "0px";
    setChangeHeaderInfoLayout(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1080);
      // setClientInfoWidth();
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [preferences, setPreferences] = useState(null);

  const [isTabletView, setisTabletView] = useState(window.innerWidth < 1080);
  const shouldBeCollapsed = preferences?.SidebarView === true ? true : false;
  // Add this new function to calculate the required width
  const calculateRequiredWidth = () => {
    const CHEVRON_WIDTH = 17; // SVG width
    const AVATAR_WIDTH = 63;
    const LEFT_PADDING = 10;
    const RIGHT_PADDING = 10;
    const GAP_BEFORE_CHEVRON = 30;
    const CHAR_WIDTH_ESTIMATE = 14;

    // Calculate width needed for client name row
    const clientNameLength = (
      client?.entity_name ||
      `${client?.last_name || ""}${client?.first_name ? `, ${client.first_name}` : ""}`
    ).length;
    const nameWidth = clientNameLength * CHAR_WIDTH_ESTIMATE;
    const nameRowWidth =
      LEFT_PADDING +
      AVATAR_WIDTH +
      5 +
      nameWidth +
      GAP_BEFORE_CHEVRON +
      CHEVRON_WIDTH +
      RIGHT_PADDING;

    // Calculate width needed for phone/birthday row
    const phoneWidth = 110; // Approximate width for formatted phone number
    const birthdayIconWidth = 15;
    const birthdayTextWidth = 70;
    const ageWidth = 60; // "Age" + number
    const gap = 30; // Gap between phone and birthday section

    const phoneRowWidth =
      LEFT_PADDING +
      AVATAR_WIDTH +
      5 +
      phoneWidth +
      gap +
      birthdayIconWidth +
      5 +
      birthdayTextWidth +
      ageWidth +
      RIGHT_PADDING;

    // Return the maximum width needed
    return Math.max(nameRowWidth, phoneRowWidth);
  };

  // Update the useEffect that calculates width
  useLayoutEffect(() => {
    if (!client) return;
    const calculatedWidth = calculateRequiredWidth();
    if (calculatedWidth !== dynamicWidth) {
      dispatch(setDynamicWidth(calculatedWidth));
    }
  }, [client, dynamicWidth, dispatch]);
  function checkDistance(el1, el2) {
    const rect1 = el1.getBoundingClientRect();
    const rect2 = el2.getBoundingClientRect();
    const horizontalDistance = Math.max(0, rect2.left - rect1.right, rect1.left - rect2.right);
    return horizontalDistance <= 30 && horizontalDistance > 0;
  }

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setPreferences(preferencesObj);
    };
    getUserPreferencesFromStorage();
  }, []);

  useEffect(() => {
    const handleResize = () => setisTabletView(window.innerWidth < 1081);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div
        className="header-wrapper-client"
        style={{
          // width: `${isSmallScreen ? dynamicWidth - 20 : dynamicWidth}px`,
          marginTop: "0.625rem",
          cursor: "pointer",
          position: "relative",
          left: "-1px",
        }}
        onClick={displayRecentCasesModal}
      >
        {/* <div className="position-fixed top-0" style={{ width:"60px",height:"10px", background:"red",top:"5px",left:"10px",zIndex:99999999 }}/> */}
        <div
          className="header-client-details"
          style={{
            zIndex: 100,
            cursor: "pointer",
          }}
        >
          <div
            className="header-client-image align-top align-self-start"
            style={{ marginLeft: "15px", marginRight: "5px", cursor: "pointer" }}
          >
            {client?.profile_pic_63p ? (
              <div
                className="image-container avatar-container"
                style={{
                  height: "60px",
                  width: "60px",
                }}
              >
                <img
                  src={client.profile_pic_63p}
                  style={{
                    cursor: "pointer",
                    height: "60px",
                    width: "60px",
                  }}
                  alt={clientInitials}
                />
                {/* <div className="border-overlay" /> */}
              </div>
            ) : (
              <div
                className="icon-container avatar-container"
                style={{
                  display: "flex",
                  height: "60px",
                  width: "60px",
                  cursor: "pointer",
                }}
              >
                {/* <i className="ic-60 ic ic-client-avatar" /> */}
                <img
                  src={avatarImage}
                  style={{
                    cursor: "pointer",
                    height: "60px",
                    width: "60px",
                    background: "var(--primary-30)",
                  }}
                  // alt={clientInitials}
                />
                {/* <div className="border-overlay" /> */}
              </div>
            )}
          </div>
          <div
            id="client-info"
            className="d-flex flex-column justify-content-between position-relative d-flex-1 z-index-1 h-100"
          >
            <div className="client-name d-flex align-items-center">
              <a
                className="clientTabFont text-black d-block client_name_header text-nowrap"
                style={{ fontSize: isLargeScreen ? "24px" : "24px" }}
                href="#"
              >
                {client && (client.last_name || client.first_name) ? (
                  <>
                    {client?.last_name}
                    {client?.first_name && (
                      <>
                        <span className="text-dark-grey">,</span>&nbsp;
                        {client.first_name}
                      </>
                    )}
                  </>
                ) : client && client.entity_name ? (
                  <>{client?.entity_name}</>
                ) : (
                  <Stack direction="row" spacing={2}>
                    <Box sx={{ width: 100 }}>
                      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                    </Box>
                    <Box sx={{ width: 100 }}>
                      <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                    </Box>
                  </Stack>
                )}
              </a>
              <span
                className="text-primary d-flex align-items-center justify-content-center chevron-header-icon"
                style={{
                  position: "absolute",
                  // right: `${dynamicWidth - 0.95 * dynamicWidth + 5}px`,
                  right: "20px",
                  top: "5px",
                }}
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 34 17"
                  fill="#19395f"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: showRecentCases ? "rotate(180deg)" : "" }}
                >
                  <path
                    d="M0.00683594 0H9.20684L17.0069 7.85384L24.807 0H34.007L17.0069 17L0.00683594 0Z"
                    fill="#19395f"
                  />
                </svg>
              </span>
            </div>
            <div
              className="align-items-center justify-content-between"
              style={{
                height: "25px",
                display: !changeHeaderInfoLayout ? "flex" : "none",
                cursor: "pointer",
              }}
            >
              {client?.person_company === "Company" ? (
                <>
                  <div
                    className="d-flex align-items-center"
                    style={{
                      gap: "5px",
                    }}
                  >
                    <span className="ic-avatar ic-15 m-0 d-flex align-items-center">
                      <i
                        // src={avatarImage}
                        className="ic ic-client"
                        style={{
                          width: "15px",
                          height: "15px",
                          cursor: "pointer",
                        }}
                      />
                    </span>

                    <p
                      className="font-weight-semibold client_birth_header"
                      // style={{ width: isSmallScreen ? "auto" : "70px", cursor: "pointer" }}
                    >
                      {client?.main_contact?.name || ""}
                    </p>
                  </div>

                  <div className="d-flex" style={{ marginRight: "9px", cursor: "pointer" }}>
                    <span
                      className="js-acc-btn text-nowrap text-black accident-type d-flex align-items-center client_phone_header text-decoration-none"
                      style={{
                        gap: "5px",
                      }}
                    >
                      <NewPhoneIcon />
                      {client && client?.main_contact?.phone_number ? (
                        client?.main_contact?.phone_number && (
                          <span className="text-black font-weight-semibold">
                            ({extractDigits(client?.main_contact?.phone_number).slice(0, 3)}){" "}
                            {extractDigits(client?.main_contact?.phone_number).slice(3, 6)}-
                            {extractDigits(client?.main_contact?.phone_number).slice(6)}
                          </span>
                        )
                      ) : (
                        <Box sx={{ width: 100 }}>
                          <Skeleton variant="text" sx={{ fontSize: "10rem" }} />
                        </Box>
                      )}
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="d-flex align-items-center"
                    style={{
                      gap: "5px",
                    }}
                  >
                    <span className="ic-avatar ic-15 m-0 d-flex align-items-center">
                      <img
                        src={birthdayIcon}
                        className=""
                        style={{
                          width: "15px",
                          height: "15px",
                          cursor: "pointer",
                        }}
                      />
                    </span>

                    <p
                      className="font-weight-semibold client_birth_header"
                      // style={{ width: isSmallScreen ? "auto" : "70px", cursor: "pointer" }}
                    >
                      {client?.birthday ? formatCalendarDate(client?.birthday) : ""}
                    </p>
                    <span className="text-primary-25" style={{ fontWeight: "600" }}>
                      age
                    </span>
                    <span className="text-black font-weight-semibold">
                      {calculateAge(client?.birthday)}
                    </span>
                  </div>

                  <div className="d-flex" style={{ marginRight: "9px", cursor: "pointer" }}>
                    <span
                      className="js-acc-btn text-nowrap text-black accident-type d-flex align-items-center client_phone_header text-decoration-none"
                      style={{
                        gap: "5px",
                      }}
                    >
                      <NewPhoneIcon />
                      {client && client?.primary_phone ? (
                        client?.primary_phone?.phone_number && (
                          <span className="text-black font-weight-semibold">
                            ({extractDigits(client?.primary_phone?.phone_number).slice(0, 3)}){" "}
                            {extractDigits(client?.primary_phone?.phone_number).slice(3, 6)}-
                            {extractDigits(client?.primary_phone?.phone_number).slice(6)}
                          </span>
                        )
                      ) : (
                        <Box sx={{ width: 100 }}>
                          <Skeleton variant="text" sx={{ fontSize: "10rem" }} />
                        </Box>
                      )}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
          <div
            className="align-items-center justify-content-between inner-header-info"
            style={{ height: "25px", display: changeHeaderInfoLayout ? "flex" : "none" }}
          >
            {client?.person_company === "Company" ? (
              <>
                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: "5px",
                  }}
                >
                  <span className="ic-avatar ic-15 m-0 d-flex align-items-center">
                    <i
                      // src={avatarImage}
                      className="ic ic-client"
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                      }}
                    />
                  </span>

                  <p
                    className="font-weight-semibold client_birth_header"
                    // style={{ width: isSmallScreen ? "auto" : "70px", cursor: "pointer" }}
                  >
                    {client?.main_contact?.name || ""}
                  </p>
                </div>

                <div className="d-flex" style={{ marginRight: "9px", cursor: "pointer" }}>
                  <span
                    className="js-acc-btn text-nowrap text-black accident-type d-flex align-items-center client_phone_header text-decoration-none"
                    style={{
                      gap: "5px",
                    }}
                  >
                    <NewPhoneIcon />
                    {client && client?.main_contact?.phone_number ? (
                      client?.main_contact?.phone_number && (
                        <span className="text-black font-weight-semibold">
                          ({extractDigits(client?.main_contact?.phone_number).slice(0, 3)}){" "}
                          {extractDigits(client?.main_contact?.phone_number).slice(3, 6)}-
                          {extractDigits(client?.main_contact?.phone_number).slice(6)}
                        </span>
                      )
                    ) : (
                      <Box sx={{ width: 100 }}>
                        <Skeleton variant="text" sx={{ fontSize: "10rem" }} />
                      </Box>
                    )}
                  </span>
                </div>
              </>
            ) : (
              <>
                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: "5px",
                  }}
                >
                  <span className="ic-avatar ic-15 m-0 d-flex align-items-center">
                    <img
                      src={birthdayIcon}
                      className=""
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                      }}
                    />
                  </span>

                  <p
                    className="font-weight-semibold client_birth_header"
                    // style={{ width: isSmallScreen ? "auto" : "70px", cursor: "pointer" }}
                  >
                    {client?.birthday ? formatCalendarDate(client?.birthday) : ""}
                  </p>
                  <span className="text-primary-25" style={{ fontWeight: "600" }}>
                    age
                  </span>
                  <span className="text-black font-weight-semibold">
                    {calculateAge(client?.birthday)}
                  </span>
                </div>

                <div className="d-flex" style={{ marginRight: "9px", cursor: "pointer" }}>
                  <span
                    className="js-acc-btn text-nowrap text-black accident-type d-flex align-items-center client_phone_header text-decoration-none"
                    style={{
                      gap: "5px",
                    }}
                  >
                    <NewPhoneIcon />
                    {client && client?.primary_phone ? (
                      client?.primary_phone?.phone_number && (
                        <span className="text-black font-weight-semibold">
                          ({extractDigits(client?.primary_phone?.phone_number).slice(0, 3)}){" "}
                          {extractDigits(client?.primary_phone?.phone_number).slice(3, 6)}-
                          {extractDigits(client?.primary_phone?.phone_number).slice(6)}
                        </span>
                      )
                    ) : (
                      <Box sx={{ width: 100 }}>
                        <Skeleton variant="text" sx={{ fontSize: "10rem" }} />
                      </Box>
                    )}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
        {caseSummary ? (
          <div
            className="header-top-user-doi"
            style={{
              // eslint-disable-next-line no-constant-binary-expression
              // width: `${isLargeScreen ?? dynamicWidth}px`,
              cursor: "pointer",
              height: "50px",
              backgroundColor: "rgb(255, 255, 255)",
              fontSize: "14px",
              marginTop: "-4px",
              clipPath: `polygon(${skewAmount2}px 0, calc(100% - ${skewAmount2}px) 0, 100% 100%, ${shouldBeCollapsed || isTabletView ? "1px" : "0px"} 100%)`,
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center w-100"
              style={{ padding: "0px 0px", height: "25px" }}
            >
              <div
                className="d-flex align-items-center"
                style={{ zIndex: "2", marginLeft: "15px" }}
              >
                {caseSummary?.case_type?.casetype_icon && (
                  <span className="ic-avatar ic-15 m-r-5 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center">
                    <img
                      style={{ width: "15px", height: "15px" }}
                      src={caseSummary?.case_type?.casetype_icon}
                      alt="icon"
                    />
                  </span>
                )}
                {client?.person_company === "Company" && (
                  <p className="font-weight-semibold client-header-case-name m-r-5">
                    {caseSummary?.case_type?.case_type_category?.name}:
                  </p>
                )}
                <p className="font-weight-semibold client-header-case-name">
                  {caseSummary?.case_type?.name}
                </p>
              </div>
              {client?.person_company !== "Company" && (
                <div
                  className="d-flex align-items-center client-header-case-date"
                  style={{ marginRight: "15px", zIndex: "2" }}
                >
                  {caseSummary.date_closed ? (
                    <div className="text-label m-r-5 color-grey-2 fw-bold">CLOSED</div>
                  ) : (
                    <div className="text-label m-r-5 color-green fw-bold">OPEN</div>
                  )}
                  <p className="font-weight-semibold">
                    {caseSummary.date_closed
                      ? formatCalendarDate(caseSummary?.date_closed)
                      : formatCalendarDate(caseSummary?.intake_date)}
                  </p>
                </div>
              )}
            </div>
            <div
              className="d-flex justify-content-between align-items-center w-100"
              style={{ padding: "0px 0px", height: "25px" }}
            >
              {client?.person_company === "Company" ? (
                <>
                  <div className="d-flex align-items-center" style={{ marginLeft: "9px" }}>
                    <span className="ic-avatar ic-15 m-r-5 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center">
                      <img
                        src={fileNumberIcon}
                        className=""
                        style={{ width: "15px", height: "15px" }}
                      />
                    </span>

                    <p className="font-weight-semibold client-header-incident-date">
                      {caseSummary?.file_number}
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex align-items-center" style={{ marginLeft: "9px" }}>
                    <span className="ic-avatar ic-15 m-r-5 text-label color-grey-2 text-uppercase fw-bold d-flex align-items-center">
                      <img
                        src={incidentIcon}
                        className=""
                        style={{ width: "15px", height: "15px" }}
                      />
                    </span>

                    <p className="font-weight-semibold client-header-incident-date">
                      {formatCalendarDate(caseSummary?.incident_date)}
                    </p>
                  </div>
                  <div className="d-flex align-items-center" style={{ marginRight: "10px" }}>
                    <div className="text-label m-r-5 color-grey-2 fw-bold client-header-incident-date-1">
                      {/* Last Accessed{" "} */}
                    </div>

                    {/* <p className="font-weight-semibold">{formatDate(last_accessed_date)}</p> */}
                    <p className="font-weight-semibold">
                      {client?.languages?.map((lang) => lang?.name).join(", ")}
                    </p>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <CustomSkeleton />
        )}
      </div>
      {showRecentCases && (
        <div
          className="header-last-accessed-client"
          id="previous-client"
          ref={dropdownRef}
          style={{
            display: "grid",
            gap: "0px",
            overflowY: "auto",
            maxHeight: "calc(100vh-119px)",
          }}
        >
          {isLoading ? (
            <PulseLoader
              loading={isLoading}
              size={16}
              aria-label="Loading Spinner"
              data-testid="loader"
              color="#19395F"
              style={{
                display: "flex",
                flexDirection: "row",
                height: "calc(100vh-119px)",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            />
          ) : (
            <>
              {lastAccessedCases?.slice(0, FilledSlotsCount)?.map((temp) => (
                <LastAccessedCases
                  data={temp}
                  extractDigits={extractDigits}
                  onClick={async (e) => {
                    e.preventDefault();
                    setIsLoading(true);
                    dispatch(setComponentLoadingEffect("medicalProviders", true));
                    dispatch(setComponentLoadingEffect("detailBar", true));
                    const clientID = temp.for_client.id;
                    const caseID = temp.id;
                    await api.get(`/api/switch_client/${clientID}/${caseID}/${page.id}/`);
                    setClientId(clientID);
                    setCaseId(caseID);
                    await validateAccessManually(clientID, caseID);
                    dispatch(fetchCurrentCase(clientID, caseID));
                    dispatch(fetchAllPages(caseID, true));
                    fetchCaseSummary(clientID, caseID).then((data) => {
                      dispatch(setCaseSummary(data));
                      dispatch(fetchAllPages(caseID));
                      setIsLoading(false);
                      setShowRecentCases(false);
                      dispatch(setBlurEffect(false));
                      dispatch(setHeaderName("Case"));
                      document.body.classList.remove("modal-open", "has-blurred-bg");
                      const menuContainer = document.getElementById("padding-top-165");
                      if (menuContainer) {
                        menuContainer.style.filter = "";
                      }
                      const divToRemove = document.querySelector(".header-blur-show");
                      if (divToRemove) {
                        document.body.removeChild(divToRemove);
                      }
                      navigate(`/bp-case/${clientID}/${caseID}`, {
                        replace: true,
                      });
                    });
                  }}
                  page={page}
                  key={temp.id}
                />
              ))}

              {Array.from({ length: EmptySlotsCount }, (_, index) => (
                <div
                  key={`empty-${index}`}
                  className={`checkerboard-slot ${
                    index % 2 === 0 ? "bg-checkerboard-primary" : "bg-checkerboard-secondary"
                  }`}
                  style={{ height: "120px" }}
                />
              ))}
            </>
          )}
        </div>
      )}
      {openingCase &&
        createPortal(
          <LoadingOverlay
            caseData={openingCase.caseData}
            caseId={openingCase.caseData.id}
            destinationPath={openingCase.path}
            overPage
          />,
          document.body
        )}
      <LastAccessedCasesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        lastAccessedCases={lastAccessedCases}
        extractDigits={extractDigits}
        isLoading={isLoading}
        error={caseSwitchError}
        onCaseClick={async (e, caseData) => {
          e.preventDefault();
          if (caseSwitchPendingRef.current) return;
          caseSwitchPendingRef.current = true;
          setCaseSwitchError("");
          const clientID = caseData.for_client.id;
          const caseID = caseData.id;
          const pageUrl = (caseData.page_url || "search").replace(/^\/+|\/+$/g, "");
          const navTarget =
            pageUrl === "search"
              ? "/search/"
              : pageUrl === "bp-medicalmin"
                ? "/treatment"
                : `/${pageUrl}/${clientID}/${caseID}`;
          setOpeningCase({ caseData, path: navTarget });

          try {
            await api.get(`/api/switch_client/${clientID}/${caseID}/${page ? page.id : "1"}/`);
          } catch (error) {
            console.error("Unable to switch case", error);
            setCaseSwitchError("Unable to open this case. Please try again.");
            setOpeningCase(null);
            caseSwitchPendingRef.current = false;
            return;
          }

          setClientId(clientID);
          setCaseId(caseID);
          setIsModalOpen(false);
          setShowRecentCases(false);
          dispatch(setBlurEffect(false));
          document.body.classList.remove("modal-open", "has-blurred-bg");
          const menuContainer = document.getElementById("padding-top-165");
          if (menuContainer) menuContainer.style.filter = "";
          document.querySelector(".header-blur-show")?.remove();

          // Navigate once, before fetching destination data. The access provider
          // owns case/header loading and receives the selected card immediately.
          navigate(navTarget, { replace: true, state: { openingCase: caseData } });
          setOpeningCase(null);
          caseSwitchPendingRef.current = false;
          dispatch(setComponentLoadingEffect("medicalProviders", true));
          dispatch(setComponentLoadingEffect("detailBar", true));
          dispatch(fetchAllPages(caseID, true));
          fetchCaseSummary(clientID, caseID)
            .then((data) => dispatch(setCaseSummary(data)))
            .catch((error) => console.error("Unable to load case summary", error));

          fetchCasePageClientProviders(clientID, caseID)
            .then((data) => {
              dispatch(setClientProviders(data?.results));
              setLoading({
                key: "all",
                value: false,
              });
              dispatch(setComponentLoadingEffect("medicalProviders", false));
            })
            .catch((error) => {
              console.error("Error occurred while fetching client-providers", error);
              dispatch(setComponentLoadingEffect("medicalProviders", false));
              setLoading({
                key: "all",
                value: false,
              });
            });
        }}
        page={page}
      />
    </>
  );
};

export default NewNavbarProfile;
